import {useMemo} from 'react';

const useLanguageSearchSelect = firms =>
  useMemo(
    () =>
      firms.map(({id, name}) => ({
        id,
        search: name.toLowerCase(),
        text: name,
      })),
    [firms]
  );

export default useLanguageSearchSelect;
